module.exports = __webpack_public_path__ + "static/ISO-9001_2015-Standards-Certificate-e9e6326c59078e71bea330bcd6033efd.pdf";